"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toEnum = exports.getKeys = exports.getEnumValue = exports.checkAllPropertiesExist = void 0;
const lodash_1 = __importDefault(require("lodash"));
const error_1 = require("../error");
// util method for confirming that all properties exist in the given typeguard
// will error log with the specific missing property when it's caught
const checkAllPropertiesExist = ({ obj, properties, forType, metadata, }) => {
    const loggerMetadata = metadata ? { ...metadata } : {};
    if (!obj) {
        throw new Error(`Object does not exist for type ${forType} ${loggerMetadata}`);
        // logger.error(`Object does not exist for type ${forType}`, {
        //   ...loggerMetadata,
        // });
    }
    return (obj &&
        lodash_1.default.every(properties, (property) => {
            const propExists = property in obj;
            if (!propExists) {
                return false;
                // NOTE:
                // We're returning false here, since logger cannot be tightly coupled here.
                // For the future iteration, we may want to inject logger (w/ common interface), and
                // log error and move on here.  Throwing exception is an another approach, but caller
                // will have to be mindful and for typeguard, it might not be the best behavior.
                //
                // logger.error(
                //   `Property \`${property}\` does not exist in object for type ${forType}`,
                //   {
                //     ...loggerMetadata,
                //   },
                // );
            }
            return propExists;
        }));
};
exports.checkAllPropertiesExist = checkAllPropertiesExist;
/**
 * Typeguard to assert value is a valid enum value. Strongly prefer {@link toEnum()}
 * where possible, since it provides better compile-time type safety.
 */
const getEnumValue = (enumType, value) => {
    const validEnumValue = lodash_1.default.includes(lodash_1.default.values(enumType), value);
    (0, error_1.finleyAssert)(validEnumValue, new error_1.TypeError({
        resourceType: 'enum',
        typeguardName: 'getEnumValue',
        metadata: { logMeta: { enumType, value } },
    }));
    return value;
};
exports.getEnumValue = getEnumValue;
/**
 * Checks at compile time that a string union type can safetly be assigned to an enum type.
 */
const toEnum = (from) => {
    // This is safe because `from` is a subtype of StringUnion<EnumT>.
    return from;
};
exports.toEnum = toEnum;
/**
 * gets typed keys of an object (instead of defaulting to string[])
 */
const getKeys = Object.keys;
exports.getKeys = getKeys;
//# sourceMappingURL=utils.js.map